import type { ElementType } from "react";
import Status from "../UI/Status";
import Text, { type Color } from "../UI/Text";

interface StatusFilterLabelProps {
  text: string;
  color?: Color;
  icon?: ElementType;
}

/** Libellé d'une option de filtre « Statut » : la même pastille que dans le tableau. */
export default function StatusFilterLabel({
  text,
  color,
  icon,
}: StatusFilterLabelProps) {
  if (!color) {
    return (
      <Text as="span" variant="deci">
        {text}
      </Text>
    );
  }
  return <Status as="span" color={color} icon={icon} text={text} />;
}
